export default "__VITE_ASSET__BaEWO_pH__"